import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchRelatedPosts } from "../../features/relatedPosts/relatedPostsSlice";
import RelatedPostsItem from "./RelatedPostsItem";

export default function RelatedPosts({ currentPostId, tags }) {
  const dispatch = useDispatch();
  const { relatedPosts, isLoading, isError, error } = useSelector(
    (state) => state.relatedPosts
  );

  useEffect(() => {
    dispatch(fetchRelatedPosts({ id: currentPostId, tags }));
  }, [dispatch, currentPostId, tags]);

  // decide what to render
  let content = null;

  if (isLoading) content = <div className="col-span-12">Loading...</div>;
  if (!isLoading && isError) {
    content = <div className="col-span-12">{error}</div>;
  }
  if (!isLoading && !isError && relatedPosts?.length === 0) {
    content = <div className="col-span-12">No related posts found!</div>;
  }
  if (!isLoading && !isError && relatedPosts?.length > 0) {
    content = relatedPosts.map((post) => (
      <RelatedPostsItem key={post.id} post={post} />
    ));
  }

  return (
    <aside>
      <h4 className="mb-4 text-xl font-medium" id="lws-relatedPosts">
        Related Posts
      </h4>
      <div className="space-y-4 related-post-container">{content}</div>
    </aside>
  );
}
